var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6668C9.84061 14.6668 11.5073 13.9206 12.7137 12.7142C13.9201 11.5078 14.6663 9.8411 14.6663 8.00016C14.6663 6.15923 13.9201 4.49256 12.7137 3.28612C11.5073 2.07969 9.84061 1.3335 7.99967 1.3335C6.15874 1.3335 4.49207 2.07969 3.28563 3.28612C2.0792 4.49256 1.33301 6.15923 1.33301 8.00016C1.33301 9.8411 2.0792 11.5078 3.28563 12.7142C4.49207 13.9206 6.15874 14.6668 7.99967 14.6668Z",
    fill: "#FD9E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4C8.55228 4 9 4.44772 9 5C9 5.55228 8.55228 6 8 6C7.44772 6 7 5.55228 7 5C7 4.44772 7.44772 4 8 4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5V11.5",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskTip);
export default __webpack_public_path__ + "static/media/risk-tip.aad5567fe8e9411023ac1ab98c40ba96.svg";
export { ForwardRef as ReactComponent };